registerGlobal( 'EmscriptenBidalgo' );

EmscriptenBidalgo.urlEvent = "https://events.bidalgo.com/maca-webapp/app/biz/event";
EmscriptenBidalgo.urlInstall = "https://events.bidalgo.com/maca-webapp/app/biz/lead";
EmscriptenBidalgo.channel = "";
EmscriptenBidalgo.appUniqueIdentifier = "";
EmscriptenBidalgo.initalized = false;
EmscriptenBidalgo.allowRequests = false;
EmscriptenBidalgo.uid = null;

EmscriptenBidalgo.init = function(channel, appUniqueIdentifier, allowRequests) {
    EmscriptenBidalgo.channel = channel;
    EmscriptenBidalgo.appUniqueIdentifier = appUniqueIdentifier;
    EmscriptenBidalgo.initalized = true;
    EmscriptenBidalgo.allowRequests = allowRequests;

    var bidalgo = false;
    var uid = null;
    var vars = window.location.search.substring(1).split("&");
    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        bidalgo = bidalgo || (pair[0] === "ref" && pair[1] === "bidalgo");
        if (pair[0] === "uid") {
            uid = pair[1];
        }
    }
    if (bidalgo) {
        EmscriptenBidalgo.uid = uid;
    }
    console.log("Bidalgo UID: " + String(EmscriptenBidalgo.uid));
}

EmscriptenBidalgo.getUID = function() {
    if (!EmscriptenBidalgo.initalized) {
        console.error("Bidalgo isn't initialized");
        return;
    }

    if (EmscriptenBidalgo.uid !== null) {
        var size = lengthBytesUTF8(EmscriptenBidalgo.uid) + 1;
        var buffer = _malloc(size);
        stringToUTF8(EmscriptenBidalgo.uid, buffer, size);
        return buffer;
    }
    else {
        return 0;
    }
}

EmscriptenBidalgo.sendInstall = function() {
    if (!EmscriptenBidalgo.initalized) {
        console.error("Bidalgo isn't initialized");
        return;
    }
    if (EmscriptenBidalgo.uid) {
        EmscriptenBidalgo.sendRequest(EmscriptenBidalgo.urlInstall, "&uid=" + EmscriptenBidalgo.uid);
    }
}

EmscriptenBidalgo.sendEvent = function(parameters) {
    if (!EmscriptenBidalgo.initalized) {
        console.error("Bidalgo isn't initialized");
        return;
    }
    EmscriptenBidalgo.sendRequest(EmscriptenBidalgo.urlEvent, parameters);
}

// temporary solution while waiting for bidalgo to fix corse configuration
// for the idea see https://stackoverflow.com/questions/22780430/javascript-xmlhttprequest-using-jsonp
EmscriptenBidalgo.call = function(url) {
    var script = document.createElement('script');
    script.src = url;
    var callback = function() {
        document.body.removeChild(script);
    };
    script.onload = callback;
    script.onerror = callback;
    document.body.appendChild(script);
}

EmscriptenBidalgo.sendRequest = function(address, parameters) {
    if (!EmscriptenBidalgo.initalized) {
        console.error("Bidalgo isn't initialized");
        return;
    }
    var url = address +
        "?channel=" + EmscriptenBidalgo.channel +
        "&appUniqueIdentifier=" + EmscriptenBidalgo.appUniqueIdentifier +
        parameters;

    if (EmscriptenBidalgo.allowRequests) {
        EmscriptenBidalgo.call(url);
    }
    else {
        console.log("Bidalgo request will be sent on prod: " + url);
    }
}



//////////////////
// WEBPACK FOOTER
// /src/contrib/huuugelibs/src/network/analytics/bidalgo/emscripten/EmscriptenBidalgo.js
// module id = 26
// module chunks = 0